var CurrentUser = require("lib/account/CurrentUser");
var DataExportMetrics = require("lib/data/DataExportMetrics.js")
import { eventToSentryRequest } from '@sentry/core';
import moment from 'moment'

require("data/exports/data_export_confirmation.scss");

class DataExportConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.state = { email: CurrentUser.get().email || '' };
    }

    ///// HELPERS /////
    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    ///// VALIDATORS /////
    validOrganizationType(selectedOrganizationType) {
        return _.includes(VALID_ORGANIZATION_TYPES, selectedOrganizationType)
    }

    validEmail() {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)
    }


    ///// HANDLERS /////
    handleOrganizationTypeChange(selectedOrganizationType) {
        this.setState({ selectedOrganizationType })
    }

    handleRetreatStage() {
        var { persistentData } = this.props
        this.props.onRetreat(persistentData)
    }

    ///// RENDER METHODS /////
    renderMetrics() {
        var { persistentData } = this.props
        var selectedMetricLabels = _.map(persistentData.selectedMetrics, m => {
            var metricCategoryConfig = DataExportMetrics.METRICS_BY_CATEGORY[persistentData.selectedMetricCategory]
            // handle addtional metrics by formatting the key
            if (metricCategoryConfig[0]['children']) {
                return m.replace(/-/g, " ").toLowerCase().split(" ").map(word => word[0].toUpperCase() + word.slice(1)).join(" ");
            } else {
                var metricConfig = _.findWhere(metricCategoryConfig, { 'key': m })
                if (metricConfig) {
                    return metricConfig.label
                }
            }
        })

        return this.renderTwoColumnRow('Selected Metrics', _.compact(selectedMetricLabels).join(', '))
    }

    renderDatePeriod() {
        var { persistentData } = this.props
        if (persistentData.selectedOrganizationType == 'chrono') {
            return this.renderTwoColumnRow('Date Period', $wr.toTitleCase(persistentData.selectedDatePeriod.replace('-', ' ')))
        }
    }

    renderDateSpan() {
        var { persistentData } = this.props
        if (persistentData.selectedMetricCategory == DataExportMetrics.ROSTER) { return null }
        var startDate = moment(persistentData.startDate).format("MM/DD/YYYY");
        var endDate = moment(persistentData.endDate).format("MM/DD/YYYY");
        var dateSpan = `${startDate} - ${endDate}`;
        
        return this.renderTwoColumnRow('Date Span', dateSpan)
    }

    renderOrganizationType() {
        var { persistentData, organizationOptions } = this.props
        
        var metricConfig = _.findWhere(organizationOptions, { 'key': persistentData.selectedOrganizationType })
        var orgLabel = metricConfig ? metricConfig.label : ''

        return this.renderTwoColumnRow('Excel Sheet Organization Type', orgLabel)
    }

    renderSelectedMetricCategory() {
        var { persistentData } = this.props
        return this.renderTwoColumnRow('Selected Metric Set', $wr.toTitleCase(persistentData.selectedMetricCategory.replace(/[-_]/g, ' ')))
    }

    renderUserSelection() {
        var { persistentData } = this.props
        var orgType = persistentData.selectedOrganizationType
        if (orgType == 'chrono' || orgType == 'per-student'){
            var count = _.size(persistentData.selectedStudents)
            return this.renderTwoColumnRow('Users', `${count} ${$wr.pluralize("Student", count)}`)
        } else if (orgType == 'per-class') {
            var count = _.size(persistentData.selectedStudentLists)
            return this.renderTwoColumnRow('Entities', `${count} ${$wr.pluralize("Class", count, "Classes")}`)
        } else if (orgType == 'per-teacher') {
            var count = _.size(persistentData.selectedTeachers)
            return this.renderTwoColumnRow('Users', `${count} ${$wr.pluralize("Teacher", count)}`)
        }
    }

    renderEmail() {
        return (
            <form className='emailForm flexRow'>
                <label className='emailLabel' htmlFor="email">Send Report To:</label>
                <input className='emailInput' type="email" name="email" value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })} />
            </form>
        )
    }

    renderConfirmationButton() {
        return (
            <div className="onSubmitContainer">
                <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                {this.validEmail() && (
                    <button className='nextBtn' onClick={() => this.props.onSubmit(this.state.email)}>Confirm Export</button>
                )}
            </div>
        )
    }

    renderTwoColumnRow(label, content) {
        return (
            <div className="flexRow">
                <div className="itemLabel">
                    <p>{label}</p>
                </div>
                <div className="selectedItems">
                    <p>{content}</p>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="confirmationConatiner">
                {this.renderDatePeriod()}
                {this.renderDateSpan()}
                {this.renderSelectedMetricCategory()}
                {this.renderMetrics()}
                {this.renderOrganizationType()}
                {this.renderUserSelection()}
                {this.renderEmail()}
                {this.renderConfirmationButton()}
            </div>
        )
    }
}

DataExportConfirmation.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

var VALID_ORGANIZATION_TYPES = ['chrono', 'per-student', 'per-class']

module.exports = DataExportConfirmation;



// WEBPACK FOOTER //
// ./modules/components/data/exports/DataExportConfirmation.js